import { UserCircleIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useAuth } from "@/contexts/auth-context";
import { DangerZoneSection } from "./danger-zone-section";

export function EndUserProfileTab() {
	const { t } = useTranslation();
	const { user } = useAuth();

	return (
		<Card>
			<CardContent className="flex flex-col gap-4 pt-6">
				<div className="flex items-center gap-4">
					<div className="flex size-16 items-center justify-center rounded-full bg-muted">
						<UserCircleIcon
							aria-hidden="true"
							className="size-9 text-muted-foreground"
						/>
					</div>
					<div>
						<p className="font-medium">{user?.username ?? "—"}</p>
						<p className="text-sm text-muted-foreground">
							{t("settings.profile.email")}
						</p>
					</div>
				</div>

				<Separator />

				<DangerZoneSection />
			</CardContent>
		</Card>
	);
}
